import type { z } from 'zod'

import { ResponseParseError } from '~/utils/ResponseParseError'

export const parseResponse = <Schema extends z.ZodType>(
  schema: Schema,
  body: unknown,
  url: string
): z.output<Schema> => {
  const result = schema.safeParse(body)
  if (result.success) return result.data
  throw new ResponseParseError(result.error, url)
}
